// Banco de cartelería. Cada plantilla: grupo, campos que rellena el usuario, valores por defecto a partir del evento
// y textos. Tamaños en mm sobre A4 horizontal; en A3 todo se multiplica por √2.

export const ddmmaa = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y.slice(2)}`;
};
const h = (v) => v || "__:__";
const f = (v) => ddmmaa(v) || "__/__/__";
const mot = (v) => v || "____";

export const FORMATOS = {
  A4: { label: "A4", w: 297, h: 210, k: 1 },
  A3: { label: "A3", w: 420, h: 297, k: Math.SQRT2 },
};

export const GRUPOS = { vallas: "Vallas · prohibido parar", garajes: "Garajes" };

const RESTRICCION = {
  entrada: { label: "Entrada", titulo: "PROHIBIDA LA ENTRADA AL GARAJE", verbo: "entrar en el garaje" },
  salida: { label: "Salida", titulo: "PROHIBIDA LA SALIDA DEL GARAJE", verbo: "salir del garaje" },
  ambas: { label: "Entrada y salida", titulo: "PROHIBIDO ENTRAR Y SALIR DEL GARAJE", verbo: "entrar ni salir del garaje" },
};
const campoRestriccion = { k: "restriccion", label: "Se prohíbe", tipo: "select", opciones: Object.entries(RESTRICCION).map(([v, o]) => ({ v, label: o.label })) };
const defaultsEvento = (ev) => ({ fecha: ev.date || "", fecha_hasta: ev.date || "", hora: ev.start_time || "", hora_hasta: ev.end_time || "", motivo: ev.name || "", restriccion: "entrada", dias: "" });

export const PLANTILLAS = [
  {
    id: "vallas", grupo: "vallas",
    nombre: "Desde una hora",
    descripcion: "R-307 · desde la hora y el día indicados (sin hora de fin).",
    senal: () => "r307",
    campos: [
      { k: "hora", label: "Desde las (hora)", tipo: "time" },
      { k: "fecha", label: "Del día", tipo: "date" },
      { k: "motivo", label: "Con motivo de", tipo: "text", placeholder: "la Procesión del Carmen" },
    ],
    defaults: defaultsEvento,
    titulo: () => "La Policía Local INFORMA",
    texto: (d) => `Desde las ${h(d.hora)} horas del ${f(d.fecha)} con motivo de ${mot(d.motivo)}`,
  },
  {
    id: "vallas_franja", grupo: "vallas",
    nombre: "Franja horaria de un día",
    descripcion: "R-307 · de una hora a otra el mismo día.",
    senal: () => "r307",
    campos: [
      { k: "fecha", label: "Día", tipo: "date" },
      { k: "hora", label: "Desde las", tipo: "time" },
      { k: "hora_hasta", label: "Hasta las", tipo: "time" },
      { k: "motivo", label: "Con motivo de", tipo: "text", placeholder: "la Carrera popular" },
    ],
    defaults: defaultsEvento,
    titulo: () => "La Policía Local INFORMA",
    destacado: () => "PROHIBIDO PARAR Y ESTACIONAR",
    texto: (d) => `El ${f(d.fecha)}, de ${h(d.hora)} a ${h(d.hora_hasta)} horas, con motivo de ${mot(d.motivo)}. Los vehículos serán retirados por la grúa.`,
  },
  {
    id: "vallas_dias", grupo: "vallas",
    nombre: "Varios días",
    descripcion: "R-307 · intervalo de días con horario (y días de la semana si hace falta).",
    senal: () => "r307",
    campos: [
      { k: "fecha", label: "Del día", tipo: "date" },
      { k: "fecha_hasta", label: "Al día", tipo: "date" },
      { k: "dias", label: "Solo los días (opcional)", tipo: "text", placeholder: "sábados y domingos" },
      { k: "hora", label: "Desde las", tipo: "time" },
      { k: "hora_hasta", label: "Hasta las", tipo: "time" },
      { k: "motivo", label: "Con motivo de", tipo: "text", placeholder: "las Fiestas del Carmen" },
    ],
    defaults: defaultsEvento,
    titulo: () => "La Policía Local INFORMA",
    destacado: () => "PROHIBIDO PARAR Y ESTACIONAR",
    texto: (d) => `Del ${f(d.fecha)} al ${f(d.fecha_hasta)}${d.dias ? ` (${d.dias})` : ""}, de ${h(d.hora)} a ${h(d.hora_hasta)} horas, con motivo de ${mot(d.motivo)}. Los vehículos serán retirados por la grúa.`,
  },
  {
    id: "garaje_dia", grupo: "garajes",
    nombre: "Garaje · un día",
    descripcion: "Entrada, salida o ambas prohibidas en una franja horaria.",
    senal: (d) => `garaje_${d.restriccion || "entrada"}`,
    campos: [
      campoRestriccion,
      { k: "fecha", label: "Día", tipo: "date" },
      { k: "hora", label: "Desde las", tipo: "time" },
      { k: "hora_hasta", label: "Hasta las", tipo: "time" },
      { k: "motivo", label: "Con motivo de", tipo: "text", placeholder: "la Procesión del Carmen" },
    ],
    defaults: defaultsEvento,
    titulo: () => "AVISO A LOS USUARIOS DEL GARAJE",
    destacado: (d) => (RESTRICCION[d.restriccion] || RESTRICCION.entrada).titulo,
    texto: (d) => d.texto_libre || `El ${f(d.fecha)}, de ${h(d.hora)} a ${h(d.hora_hasta)} horas, no se podrá ${(RESTRICCION[d.restriccion] || RESTRICCION.entrada).verbo} con motivo de ${mot(d.motivo)}. Disculpen las molestias. — La Policía Local`,
  },
  {
    id: "garaje_dias", grupo: "garajes",
    nombre: "Garaje · varios días",
    descripcion: "Intervalo de días, días de la semana y horario.",
    senal: (d) => `garaje_${d.restriccion || "entrada"}`,
    campos: [
      campoRestriccion,
      { k: "fecha", label: "Del día", tipo: "date" },
      { k: "fecha_hasta", label: "Al día", tipo: "date" },
      { k: "dias", label: "Solo los días (opcional)", tipo: "text", placeholder: "de lunes a viernes" },
      { k: "hora", label: "Desde las", tipo: "time" },
      { k: "hora_hasta", label: "Hasta las", tipo: "time" },
      { k: "motivo", label: "Con motivo de", tipo: "text", placeholder: "las obras de la Rúa Real" },
    ],
    defaults: defaultsEvento,
    titulo: () => "AVISO A LOS USUARIOS DEL GARAJE",
    destacado: (d) => (RESTRICCION[d.restriccion] || RESTRICCION.entrada).titulo,
    texto: (d) => d.texto_libre || `Del ${f(d.fecha)} al ${f(d.fecha_hasta)}${d.dias ? ` (${d.dias})` : ""}, de ${h(d.hora)} a ${h(d.hora_hasta)} horas, no se podrá ${(RESTRICCION[d.restriccion] || RESTRICCION.entrada).verbo} con motivo de ${mot(d.motivo)}. Disculpen las molestias. — La Policía Local`,
  },
];
